import { render, staticRenderFns } from "./regIndex.vue?vue&type=template&id=40a49953&scoped=true&"
import script from "./regIndex.vue?vue&type=script&lang=js&"
export * from "./regIndex.vue?vue&type=script&lang=js&"
import style0 from "./regIndex.vue?vue&type=style&index=0&id=40a49953&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a49953",
  null
  
)

export default component.exports